export default class ModalComponent extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickModal = this.onClickModal.bind(this);
  }

  //
  // Handle connect.
  //
  connectedCallback() {
    // Vars
    this._node = this;
    this._modal_scroll = this._node.querySelector(".modal-scroll");
    this._dialog_box = this._node.querySelectorAll(".dialog-box");
    this._customer_portal = document.getElementById("customer-portal");

    const config = { attributes: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          let mutation_name = mutation.attributeName;
          if (mutation_name.includes("open") && mutationList.length <= 1) {
            let id = mutation_name.replace('data-open_', '');
            this.setDialogBox(id);
            this._node.offsetHeight;
            this.openModal();
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(this._node, config);

    // Events
    this._node.addEventListener("click", this.onClickModal);

    // Reset
    this.removeDatasets();
  }

  removeDatasets() {
    Object.keys(this._node.dataset).forEach((data_key) => {
      delete this._node.dataset[data_key];
    });
  }

  //
  // Open modal.
  //
  openModal() {
    this._node.classList.add("--show");
    document.body.style.overflow = 'hidden';
  }

  //
  // Close modal.
  //
  closeModal() {
    this._node.classList.remove("--show");
    document.body.style.overflow = '';
    this.removeDatasets();
  }

  //
  // Click modal.
  //
  onClickModal(e) {
    let target = e.target,
        closeClasses = ['modal-scroll', 'content', 'basic-btn'];

    if (target.classList.contains('confirm-modal-btn')) {
      let mid = target.closest('.dialog-box').getAttribute('data-mid');

      if (mid === "store_credit_unapply") {
        let apply_credit = false;
        this._customer_portal.submitStoreCredit(apply_credit);
      }
      if (mid === "store_credit_apply") {
        let apply_credit = true;
        this._customer_portal.submitStoreCredit(apply_credit);
      }
    }

    if (closeClasses.some((className) => target.classList.contains(className))) {
      this.closeModal();
    }
  }

  setDialogBox(id) {
    this._dialog_box.forEach((el) => {
      let mid = el.getAttribute('data-mid');

      if (mid === id) {
        el.style.display = "flex";
      } else {
        el.style.display = "none";
      }
    });

  }

  //
  // Handle disconnect.
  //
  disconnectedCallback() {
    this._node.removeEventListener("click", this.onClickModal);
  }
}
